(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-header"]) return;
  try {
    
if (!customElements.get('editorial-live-search')) {
  customElements.define('editorial-live-search', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      this.input = this.querySelector('input[name="q"]');
      this.results = this.querySelector('[data-live-results]');
      this.status = this.querySelector('[data-live-status]');
      this.input.addEventListener('input', () => this.schedule(), {signal});
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.results.hidden) {
          event.preventDefault(); event.stopPropagation(); this.dismiss();
        }
        if (event.key === 'ArrowDown' && !this.results.hidden) {
          event.preventDefault(); this.results.querySelector('a')?.focus();
        }
      }, {signal});
      this.results.addEventListener('keydown', event => {
        const links = [...this.results.querySelectorAll('a')];
        const index = links.indexOf(document.activeElement);
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.dismiss(); this.input.focus(); }
        if (event.key === 'ArrowDown') { event.preventDefault(); links[Math.min(index + 1, links.length - 1)]?.focus(); }
        if (event.key === 'ArrowUp') { event.preventDefault(); if (index <= 0) this.input.focus(); else links[index - 1]?.focus(); }
      }, {signal});
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.dismiss(); }, {signal});
      this.closest('dialog')?.addEventListener('close', () => this.dismiss(), {signal});
    }
    dismiss() {
      clearTimeout(this.timer); this.request?.abort(); this.sequence = (this.sequence || 0) + 1;
      this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false');
      this.results.removeAttribute('aria-busy'); this.status.textContent = '';
    }
    schedule() {
      this.dismiss();
      const query = this.input.value.trim();
      if (query.length < 2) return;
      this.timer = setTimeout(() => this.search(query), 250);
    }
    async search(query) {
      const sequence = this.sequence;
      this.request = new AbortController();
      this.status.textContent = this.dataset.loading;
      this.results.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.dataset.endpoint, location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '4');
        url.searchParams.set('section_id', 'editorial-search-results');
        const response = await fetch(url, {signal: this.request.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (sequence !== this.sequence || query !== this.input.value.trim()) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-editorial-suggestions]');
        if (!content) throw new Error('Missing results');
        this.results.replaceChildren(...content.childNodes);
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.status.textContent = this.results.querySelector('[data-result-status]')?.textContent || '';
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === this.sequence) {
          this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false');
        }
      } finally {
        if (sequence === this.sequence) { this.results.removeAttribute('aria-busy'); if (this.results.hidden) this.status.textContent = ''; }
      }
    }
    disconnectedCallback() { this.dismiss(); this.lifecycle?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('editorial-product')) customElements.define('editorial-product', class extends HTMLElement {
  connectedCallback() {
    this.lifecycle?.abort();this.lifecycle=new AbortController();const signal=this.lifecycle.signal;
    this.track=this.querySelector('[data-track]');this.slides=[...this.querySelectorAll('[data-media]')];this.variant=this.querySelector('[data-variant]');this.qty=this.querySelector('[data-quantity]');this.add=this.querySelector('[data-add]');this.form=this.querySelector('.ep-form');
    this.querySelectorAll('[data-thumb]').forEach(button=>button.addEventListener('click',()=>this.goTo(button.dataset.thumb),{signal}));
    this.querySelector('[data-prev]')?.addEventListener('click',()=>this.move(-1),{signal});this.querySelector('[data-next]')?.addEventListener('click',()=>this.move(1),{signal});
    this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.syncGallery());},{signal,passive:true});
    this.track.addEventListener('keydown',e=>{if(e.target===this.track&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}},{signal});
    this.variant.addEventListener('change',()=>this.updateVariant(),{signal});
    this.querySelector('[data-minus]').addEventListener('click',()=>{this.qty.stepDown();this.syncQuantity();},{signal});this.querySelector('[data-plus]').addEventListener('click',()=>{this.qty.stepUp();this.syncQuantity();},{signal});this.qty.addEventListener('input',()=>this.syncQuantity(),{signal});
    const dialog=this.querySelector('.ep-zoom');this.querySelectorAll('[data-zoom]').forEach(button=>button.addEventListener('click',()=>{this.returnFocus=button;const image=button.querySelector('img').cloneNode();image.removeAttribute('loading');this.querySelector('[data-zoom-image]').replaceChildren(image);dialog.showModal();},{signal}));this.querySelector('[data-zoom-close]').addEventListener('click',()=>dialog.close(),{signal});dialog.addEventListener('close',()=>this.returnFocus?.focus(),{signal});
    const sticky=this.querySelector('[data-sticky]');if(sticky){this.buyObserver=new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting;},{threshold:0});this.buyObserver.observe(this.form);this.footerObserver=new IntersectionObserver(entries=>{this.footerVisible=entries[0].isIntersecting;sticky.style.visibility=this.footerVisible?'hidden':'';});const footer=document.querySelector('footer');if(footer)this.footerObserver.observe(footer);this.querySelector('[data-sticky-add]').addEventListener('click',()=>this.form.requestSubmit(this.add),{signal});}
    this.syncQuantity();const selected=this.variant.selectedOptions[0];if(selected?.dataset.media)this.goTo(selected.dataset.media,'instant');this.syncGallery();
  }
  goTo(id,behavior){const slide=this.slides.find(s=>s.dataset.media===String(id));if(!slide)return;this.track.scrollTo({left:slide.offsetLeft-this.slides[0].offsetLeft,behavior:behavior||(matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth')});}
  move(direction){const index=Math.round(this.track.scrollLeft/(this.track.clientWidth||1));this.goTo(this.slides[Math.max(0,Math.min(this.slides.length-1,index+direction))]?.dataset.media);}
  syncGallery(){const index=Math.round(this.track.scrollLeft/(this.track.clientWidth||1));const active=this.slides[index];this.querySelectorAll('[data-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.thumb===active?.dataset.media)));const count=this.querySelector('[data-counter]');if(count)count.textContent=`${index+1} / ${this.slides.length}`;this.querySelector('[data-prev]')?.toggleAttribute('disabled',index===0);this.querySelector('[data-next]')?.toggleAttribute('disabled',index>=this.slides.length-1);this.slides.forEach(s=>{if(s!==active)s.querySelectorAll('video').forEach(v=>v.pause());});}
  syncQuantity(){const value=Number(this.qty.value),min=Number(this.qty.min||1),max=this.qty.max?Number(this.qty.max):Infinity;this.querySelector('[data-minus]').disabled=value<=min;this.querySelector('[data-plus]').disabled=value>=max;}
  updateVariant(){const option=this.variant.selectedOptions[0];if(!option)return;this.querySelector('[data-price]').textContent=option.dataset.price;const compare=this.querySelector('[data-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare||this.dataset.showCompare!=='true';const available=option.dataset.available==='true';this.add.disabled=!available;this.add.textContent=available?`${this.add.dataset.label} — ${option.dataset.price}`:this.add.dataset.soldOut;const sticky=this.querySelector('[data-sticky-add]');if(sticky){sticky.disabled=!available;sticky.textContent=this.add.textContent;}const thumb=this.querySelector('.ep-sticky-image');if(thumb&&option.dataset.thumbnail){thumb.src=option.dataset.thumbnail;thumb.removeAttribute('srcset');}this.qty.min=option.dataset.min||1;this.qty.step=option.dataset.step||1;if(option.dataset.max)this.qty.max=option.dataset.max;else this.qty.removeAttribute('max');this.qty.value=this.qty.min;this.syncQuantity();if(option.dataset.media)this.goTo(option.dataset.media);const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}
  disconnectedCallback(){this.lifecycle?.abort();this.buyObserver?.disconnect();this.footerObserver?.disconnect();cancelAnimationFrame(this.frame);this.querySelector('.ep-zoom')?.close();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furway-help"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => document.querySelectorAll('.fw-help').forEach(root => {
    if(root.dataset.ready) return;
    root.dataset.ready = 'true';
    const offset = () => {
      let bottom = 0;
      document.querySelectorAll('#shopify-section-editorial-header, sticky-header, .header-wrapper, .ed-header, .ed-announcement').forEach(el => {
        const r = el.getBoundingClientRect();
        let owner = el;
        while(owner && owner !== document.body) {
          if(['sticky','fixed'].includes(getComputedStyle(owner).position)) {
            if(r.height && r.top < innerHeight && r.bottom > 0) bottom = Math.max(bottom, Math.min(r.bottom,r.height));
            break;
          }
          owner = owner.parentElement;
        }
      });
      const value = Math.max(24,bottom + 24);
      root.style.setProperty('--fw-help-offset',value+'px');
      return value;
    };
    const select = id => root.querySelectorAll('[data-help-topic]').forEach(link => {
      if(root.dataset.helpMode === 'faq' && link.dataset.helpTopic === id) link.setAttribute('aria-current','location');
      else link.removeAttribute('aria-current');
    });
    const targetFor = id => Array.from(root.querySelectorAll('.fw-help-topic')).find(el => el.id === id);
    const move = (topic,focus = false) => {
      const heading = topic.querySelector('h2') || topic;
      const top = Math.max(0,window.scrollY + heading.getBoundingClientRect().top - offset());
      window.scrollTo({top,behavior:'instant'});
      if(focus) {
        heading.setAttribute('tabindex','-1');
        heading.focus({preventScroll:true});
      }
    };
    const applyHash = () => {
      const success = root.querySelector('.fw-help-success');
      if (success) {
        requestAnimationFrame(() => {
          const inset = offset();
          const available = Math.max(0, window.innerHeight - inset);
          const gap = Math.max(24, (available - success.getBoundingClientRect().height) / 2);
          const top = Math.max(0, window.scrollY + success.getBoundingClientRect().top - inset - gap);
          window.scrollTo({top, behavior:'instant'});
          success.focus({preventScroll:true});
        });
        return;
      }
      if(root.dataset.helpMode !== 'faq') return;
      const topic = targetFor(location.hash.slice(1));
      select(topic ? topic.id : 'faq');
      if(topic) requestAnimationFrame(() => move(topic));
    };
    document.addEventListener('click',event => {
      if(root.dataset.helpMode !== 'faq' || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if(!link || link.target === '_blank') return;
      const url = new URL(link.href,location.href);
      if(url.origin !== location.origin || url.pathname.replace(/\/$/,'') !== location.pathname.replace(/\/$/,'')) return;
      const topic = targetFor(url.hash.slice(1));
      if(!topic) return;
      event.preventDefault();event.stopImmediatePropagation();
      history.pushState(null,'',url.hash);
      select(topic.id);move(topic,true);
      requestAnimationFrame(() => move(topic));
    },true);
    window.addEventListener('hashchange',applyHash);
    window.addEventListener('popstate',applyHash);
    window.addEventListener('resize',offset);
    offset();applyHash();
    document.fonts.ready.then(applyHash);
    if(document.readyState !== 'complete') window.addEventListener('load',applyHash,{once:true});
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
